import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import LandingCtaButton from '../shared/LandingCtaButton';
import { CTAS } from '../landingContent';
import { LANDING_COLORS, LANDING_FONTS, LANDING_LIGHT_BAND_BG } from '../landingVisual';

const FinalCtaSection = () => (
  <Box
    component="section"
    id="get-started"
    sx={{
      py: { xs: 8, md: 10 },
      textAlign: 'center',
      fontFamily: LANDING_FONTS.sans,
      background: LANDING_LIGHT_BAND_BG,
      color: LANDING_COLORS.ink,
      borderTop: `1px solid ${LANDING_COLORS.line}`,
    }}
  >
    <Container maxWidth="md">
      <Typography
        variant="h3"
        component="h2"
        sx={{
          fontFamily: LANDING_FONTS.sans,
          fontWeight: 700,
          letterSpacing: '-0.03em',
          mb: 1.5,
          fontSize: { xs: '1.75rem', md: '2.25rem' },
        }}
      >
        Ready to Transform Hiring?
      </Typography>
      <Typography
        sx={{
          mb: 4,
          color: LANDING_COLORS.onLightMuted,
          maxWidth: 520,
          mx: 'auto',
          lineHeight: 1.6,
        }}
      >
        Start practicing today, or book a walkthrough for your recruiting team.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 1.5,
          justifyContent: 'center',
          flexWrap: 'wrap',
          maxWidth: 800,
          mx: 'auto',
        }}
      >
        <LandingCtaButton
          to={CTAS.signup.to}
          label={CTAS.signup.label}
          variant={CTAS.signup.variant}
        />
        <LandingCtaButton
          to={CTAS.demoAlt.to}
          label={CTAS.demoAlt.label}
          variant={CTAS.demoAlt.variant}
        />
        <LandingCtaButton
          to={CTAS.interviewer.to}
          label={CTAS.interviewer.label}
          variant={CTAS.interviewer.variant}
        />
      </Box>
    </Container>
  </Box>
);

export default FinalCtaSection;
